import React from "react";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import moment from "moment";
import henceforthApi from "../utils/henceforthApi";
import { Table, Avatar, Spin, Tabs, Tag, Button } from "antd";
import { Link } from "react-router-dom";
import { getUserProfileImage } from "../utils/constant_value";

function MessageList({ loading, messages }) {
  return (
    <div>
      <div className="row">
        {!loading && messages?.length ? (
          messages.map((item, index) => {
            return (
              <div
                className="col-sm-6"
                key={index}
              >
                <div
                  className="modal-wrapper d-flex justify-content-between align-items-start"
                  style={{
                    border: "1px solid #e5e5e5",
                    borderRadius: "5px",
                    padding: "10px",
                    marginBottom: "10px",
                  }}
                >
                  {/* Left: Sender Image */}
                 <div className="image-name-box d-flex gap-2 align-items-start w-100">
  {/* Left: Avatar */}
  <div className="flex-shrink-0">
    <Avatar
      src={getUserProfileImage(item?.sent_by?.profile_pic, 'medium')}
    />
  </div>

                    {/* Right: Name and Message */}
                    <div className="flex-grow-1">
                      {/* First Row: Name only (full width) */}
                      <div className="w-100">
                        <p className="m-0" style={{ fontSize: "15px" }}>
                          <Link
                            to={`/user/${item?.sent_by?._id}/1/1?type=posts`}
                            className="Details_of_User"
                          >
                            {item?.sent_by?.full_name || "-"}
                          </Link>
                        </p>
                      </div>

                      {/* Second Row: Message and Date */}
                      <div className="d-flex justify-content-between align-items-center mt-1">
                        {/* Message */}
                        <div className="flex-grow-1">
                          {item?.message_type === "TEXT" ? (
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              {item?.message}
                            </span>
                          ) : (
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              [{item?.message_type}]
                            </span>
                          )}
                        </div>

                        {/* Date */}
                        <div className="flex-shrink-0 ms-2">
                          <p
                            className="m-0"
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: "#888",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {moment(Number(item?.created_at)).format("DD MMM YYYY, h:mm a")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center">No Messages Found</div>
        )}
      </div>
    </div>
  );
}

export default MessageList;
